module.exports = __webpack_public_path__ + "static/img/banner.e4745f5a.png";